<div class="subheader with-padding flgrow">
  <div  class="row">
    <div class="col-lg-4 col-md-6 col-sm-8">
      <div class="flmid relative">
          <div class="input-group flgrow">
              <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
                [(ngModel)]="searchTerm" autocomplete="off" (keyup.enter)="onEnterPress()" />
              <div class="input-group-append">
                <button type="button" class="btn btn-primary" (click)="onSearchFilter()">
                  <em class="fa fa-search font17"></em>
                </button>
              </div>
            </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
      <ng-select placeholder="{{ 'lblSelectItemSalesPriceGroup' | translate }}" [(ngModel)]="itemSalesPriceGroup"  (change)="ItemSalesPriceGroupChange($event)">
        <ng-option *ngFor="let type of laborAndItemSalesPriceList?.itemSalesPrice">
          {{type.code}}</ng-option>
      </ng-select>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-6">
      <ng-select placeholder="{{ 'lblSelectMake' | translate }}" [(ngModel)]="brandCode"  (change)="ItemMakeCodeChange($event)">
        <ng-option *ngFor="let type of makeList">
          {{type.brandCode}}</ng-option>
      </ng-select>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex justify-content-between" translate>
          lblPartSalesPriceCalculation
          <div class="font16 fontbold">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
            totalCount
            }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
          </div>
        </div>
        <div class="table-responsive max-h232" infinite-scroll [infiniteScrollDistance]="scrollDistance" 
                [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="loadMoreData($event)">
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th style="width: 40px" scope="col" sortable="itemSalesPriceGroup" (sort)="onSort($event)"
                  translate>
                  lblItemSalesPriceGroup</th>
                <th style="width: 40px" scope="col" sortable="makeCode" (sort)="onSort($event)" translate>
                  lblMakeCode
                </th>
                <th style="width: 40px" scope="col" sortable="itemGroup" (sort)="onSort($event)" translate>
                  lblItemGroup</th>
                <th style="width: 40px" scope="col" translate>lblItemPriceBase</th>
                <th class="text-right" style="width: 40px" scope="col" translate>lblSurcharge</th>
                <th class="text-right" style="width: 40px" scope="col" translate>lblDiscount</th>
                <th style="width: 40px" scope="col" translate>lblItemPriceCategory</th>
                <th style="width: 40px" scope="col" translate>lblPriceSelection</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="partPriceList?.length>0; else load_else">
                <tr *ngFor="let item of partPriceList; let i=index">
                  <td>{{i+1}}</td>
                  <td>{{item.itemSalesPriceGroup}}</td>
                  <td>{{item.makeCode}}</td>
                  <td>{{item.itemGroup ? item.itemGroup : '-'}}</td>
                  <td>{{item.itemPriceBase}}</td>
                  <td class="text-right">{{item.surcharge | number: '1.2-2'}}</td>
                  <td class="text-right">{{item.discount | number: '1.2-2'}}</td>
                  <td>{{item.itemPriceCategory}}</td>
                  <td>{{item.priceSelection}}</td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="9" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</div>
   